<template>
  <v-container fluid grid-list-md>
    <div>
      <!-- slot para ativar no componente pai a troca de arquivos -->
      <div v-if="disabled" style="color: rgba(0,0,0,.38)">
        
        <v-tooltip bottom>
          <slot slot="activator" name="activator"></slot>
          <span>Imagem bloqueada para edição.</span>
        </v-tooltip>
      </div>
      <div v-else @click="launchFilePicker()">
        <slot name="activator"></slot>
      </div>
      <!-- image input: style é setado para esconder e é adicionado um ref para dar um triggered -->
      <!-- o evento do click recebe null para permitir selecionar a mesma foto selecioanda anteriormente -->
      <input type="file"
        ref="file"
        :name="uploadFieldName"
        @change="onFileChange($event.target.name, $event.target.files)"
        @click="$event.target.value = null"
        style="display:none">
      <!-- dialog de erros -->
      <v-dialog v-model="errorDialog" max-width="300">
        <v-card>
          <v-card-text class="subheading">{{errorText}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="errorDialog = false" flat>OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-layout wrap justify-left align-center>
      <v-dialog v-model="dialogCropImage" persistent scrollable max-width="500px">
        <v-card style="max-width: 800px; max-height: 800px;">
          <v-card-title primary-title>
            <span class="title">Recortar imagem</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-flex v-if="objectUrl">
              <v-layout row wrap justify-center align-center>
                <v-flex xs12>
                  <vue-cropper class="mr-2 w-50" ref='cropper' :guides="true" :aspectRatio="1" :src="objectUrl"></vue-cropper>
                  <v-flex xs12 justify-center>
                      <v-btn small @click="rotateLeft">
                          <v-icon>rotate_left</v-icon>
                      </v-btn>
                      <v-btn small @click="rotateRight">
                          <v-icon>rotate_right</v-icon>
                      </v-btn>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" color="primary darken-2" :disabled="!objectUrl" @click="save()">Confirmar</v-btn>
            <v-btn class="mx-0" @click="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<style scoped>
.image-container {
  display: inline-block;
  border-radius: 50%;
}

.image-preview{
  display: block;
  height: 250px;
  max-width: 100%;
  border-radius: 50%;
}

.gradient {
  background: linear-gradient(40deg, #4a97ce, #5fbf8d);
}
</style>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  components: {
    VueCropper
  },
  name: 'p-upload-cropped-image',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      objectUrl: null,
      dialogCropImage: false,
      field: '',
      // carregamemto da imagem
      errorDialog: null,
      errorText: '',
      uploadFieldName: 'file',
      form: {},
      maxSize: 1024
    }
  },
  methods: {
    launchFilePicker () {
      this.$refs.file.click()
    },
    onFileChange (fieldName, file) {
      const { maxSize } = this
      let imageFile = file[0]
      // Conferir se foi selecionado algum arquivo
      if (file.length > 0) {
        let size = imageFile.size / maxSize / maxSize
        if (!imageFile.type.match('image.*')) {
          // Conferir se o arquivo selecionado é imagem
          this.errorDialog = true
          this.errorText = 'Por favor, selecione um arquivo de imagem'
        } else if (size > 5) {
          // Conferir se o tamanho está dentro do permitido
          this.errorDialog = true
          this.errorText = 'Arquivo de imagem deve pesar até 5mb'
        } else {
          this.field = fieldName
          this.objectUrl = URL.createObjectURL(imageFile)
          this.$nextTick(this.setupCropper)
          this.openCrop()
        }
      } else {
        this.$refs.cropper = null
        this.objectUrl = null
      }
    },
    rotateLeft () {
      this.$refs.cropper.rotate(-90)
    },
    rotateRight () {
      this.$refs.cropper.rotate(90)
    },
    setupCropper () {
      this.$refs.cropper.replace(this.objectUrl)
    },
    save () {
      const canvas = this.$refs.cropper.getCroppedCanvas()
      let imageURL = canvas.toDataURL('image/png')
      canvas.toBlob((blob) => {
        const formData = new FormData()
        formData.append(this.field, blob)
        this.form = formData
        // Emit FormData & imagem URL para o componente pai
        this.$emit('input', imageURL)
        this.$emit('changeImage', formData)
      })
      this.close()
    },
    openCrop () {
      this.dialogCropImage = true
    },
    close () {
      this.dialogCropImage = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/PUploadCroppedImage.vue